<template>
  <b-container>
    <evaluation-node-information
      :requirement="getSelectedRequirement"
      :status="getSavingStatus"
    >
      <template #title>
        <h4>{{ $t("label_evaluation_requirementEvaluation_requirementCard") }}</h4>
      </template>
      <template #additionalTemplate>
        <b-container>
          <b-row>
            <b-col class="col-h4" cols="5">
            <div class="subTitle">
                {{ $t("label_evaluation_status") }}
            </div>
              <b-form-select
                id="modelabel_evaluation_administrator_node_matrix_indicator"
                v-model="evaluation_status"
                style="width: 100%"
                @change="updateEvaluationStatus"
              >
                <option
                  v-for="(option, optionIndex) of options"
                  :key="optionIndex"
                  :value="option.value"
                >
                  {{ $t(option.label) }}
                </option>
              </b-form-select>
            </b-col>
            <b-col cols="1" />
            <b-col class="col-h4" cols="5">
            <div class="subTitle">
                {{ $t("label_evaluation_requirementEvaluation_evaluatedBy") }}:
            </div>
              <span
                v-if="
                  getSelectedRequirement.userAccount &&
                  getSelectedRequirement.userAccount.account
                "
              >
                {{ getSelectedRequirement.userAccount.account.name }}
                {{ getSelectedRequirement.userAccount.account.lastName }}
              </span>
            </b-col>
          </b-row>

          <div
            v-if="evaluation_administrator_node_matrix_dimension"
            style="justify-content: left"
            class="col-h4"
          >
          <div class="subTitle">
              {{ $t("label_evaluation_requirementEvaluation_dimension") }}
          </div>
            {{ $t(evaluation_administrator_node_matrix_dimension) }}
          </div>
          <div
            v-if="evaluation_administrator_node_matrix_indicator_indicator"
            class="col-h4"
            style="justify-content: left"
          >
          <div class="subTitle">
              {{
                $t("label_evaluation_requirementEvaluation_relatedIndicators")
              }}
          </div>
            <span
              v-if="evaluation_administrator_node_matrix_indicator_indicator"
            >
              {{ evaluation_administrator_node_matrix_indicator_indicator.id }}
              -
              {{
                $t(
                  evaluation_administrator_node_matrix_indicator_indicator.name
                )
              }}</span
            >
          </div>
          <div
            v-if="evaluation_administrator_node_matrix_indicator_indicator"
            class="col-h4"
            style="justify-content: left"
          >
          <div class="subTitle">
              {{ $t("label_evaluation_requirementEvaluation_indicatorValue") }}
          </div>
            <span
              v-if="evaluation_administrator_node_matrix_indicator_indicator"
            >
              {{
                getIndicatorValue(
                  evaluation_administrator_node_matrix_indicator_indicator.value
                )
              }}
            </span>
          </div>
          <div
            v-if="
              getSelectedRequirement.evaluation_administrator_node_matrix_notes
            "
            class="col-h4"
            style="justify-content: left"
          >
          <div class="subTitle">
              {{ $t("label_evaluation_requirementEvaluation_notes") }}
          </div>
            {{
              getSelectedRequirement.evaluation_administrator_node_matrix_notes
            }}
          </div>
        </b-container>
      </template>
    </evaluation-node-information>

    <div
      v-if="
        getSelectedRequirement.evaluation_administrator_node_editRequirement_requireEvidences
      "
    >
      <evaluation-evidences-requested
        :requirement="getSelectedRequirement"
        :evaluation-id="evaluationId"
      />
    </div>
    <evaluation-node-comments :can-post-new-comment="true">
      <template #title>
        <h4>
          {{ $t("label_evaluation_requirementEvaluation_evaluationComments") }}
        </h4>
      </template>
      <template #description>
        <div>
          {{
            $t(
              "label_evaluation_requirementEvaluation_evaluationComments_description"
            )
          }}
        </div>
      </template>
    </evaluation-node-comments>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import { axiosCall } from "../../../../utils/axiosCall";
import EvaluationNodeComments from "../shared/EvaluationNodeComments.vue";
import EvaluationEvidencesRequested from "./EvaluationEvidencesRequested.vue";
import EvaluationNodeInformation from "../shared/EvaluationNodeInformation.vue";

export default {
  name: "EvaluationEvaluateNode",
  components: {
    EvaluationNodeComments,
    EvaluationEvidencesRequested,
    EvaluationNodeInformation,
  },
  props: {
    evaluationId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isOrganization: false,
      showModal: false,
      comment: {},
      improvement: {},
      evaluationStatus: null,
      options: [
        { value: null, label: "label_evaluation_pending" },
        { value: 0, label: "label_evaluation_not achieved" },
        { value: 50, label: "label_evaluation_partially achieved" },
        { value: 75, label: "label_evaluation_close to be achieved" },
        { value: 100, label: "label_evaluation_achieved" },
      ],
      evaluation_administrator_node_matrix_indicator_indicator: null,
      evaluation_administrator_node_matrix_dimension: null,
      evaluation_status: null,
    };
  },
  watch: {
    getSelectedEvaluation: function(){
    },
    getSelectedRequirement: function () {
      this.fillRequirementInfo();
    },
  },
  computed: mapGetters([
    "getLang",
    "getSavingStatus",
    "getSelectedRequirement",
    "getSelectedEvaluation"
  ]),
  mounted() {
    this.fillRequirementInfo();
  },
  methods: {
    updateEvaluationStatus: async function () {
      let updateValues = {
        evaluation_status: this.evaluation_status,
      };
      await this.$store.dispatch("updateEvaluation", {
        valuesToUpdate: updateValues,
        calculateProgress: true,
      });
    },
    async fillRequirementInfo() {
      if (this.getSelectedRequirement) {
        this.evaluation_status = this.getSelectedRequirement.evaluation_status;
        this.evaluation_administrator_node_matrix_dimension = null;
        this.evaluation_administrator_node_matrix_indicator_indicator = null;
        if (
          this.getSelectedRequirement
            .evaluation_administrator_node_matrix_indicator
        ) {
          // eslint-disable-next-line camelcase
          const data = {
            evaluationId: this.evaluationId,
            indicatorAcronym:
              this.getSelectedRequirement
                .evaluation_administrator_node_matrix_indicator,
          };
          await axiosCall({
            url: "Pillars/getIndicatorValue",
            method: "POST",
            data,
          }).then((response) => {
            // eslint-disable-next-line camelcase
            this.evaluation_administrator_node_matrix_dimension =
              response.data.pillar.id +
              " - " +
              this.$t(response.data.pillar.name);
            // eslint-disable-next-line camelcase
            this.evaluation_administrator_node_matrix_indicator_indicator =
              response.data.indicator;
          });

        }
      }
    },
    getIndicatorValue(value) {
      if (isNaN(value)) {
        return value;
      } else {
        return Number(value).toFixed(2);
      }
    },
    postImprovement() {
      if (typeof this.requirement.improvements === "undefined") {
        this.requirement.improvements = [];
      }
      this.improvement.account = this.account;
      this.improvement.date = new Date().toLocaleDateString("en-US");
      this.requirement.improvements.push(this.improvement);
      this.improvement = { ...{} };
      this.requirement.needsImprovement = true;
      this.saveAndForce();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/css/variables";

.modal {
  text-align: center;

  .modal-title {
    width: 100%;
  }
}

.breadCrumb {
  color: $primary-color;
  margin-top: 5px;
}

.subTitle {
  font-size: 1.1rem;
  text-transform: uppercase;
  padding-right: 10px;
  font-family: $font-title;
}

.cardContainer {
  border-color: #6e6e6e;
  padding: 20px;
  margin-bottom: 15px;
  font-size: 1rem;

  h4 {
    font-size: 1.3rem;
    text-transform: uppercase;
    margin: 0px;
    padding: 0px;
    padding-right: 15px;
  }
}

.col-h4 {
  display: flex;
  align-items: center;
}
</style>
